<template>
  <Section class="p-4 sm:p-6 lg:p-10">
    <div class="p-4 mb-6 bg-white rounded-lg sm:p-6 md:mb-10 ">
      <h1 class="text-center text-lg md:text-2xl lg:text-3xl mb-2 md:mb-4">
        Are you sure you want to downgrade to free?
      </h1>

      <p
        class="text-center text-sm font-bold md:text-base text-danger-dark mb-8 max-w-xs mx-auto md:max-w-sm"
      >
        Be aware that this could cause the following effects to any newsletters
        you previously sent:
      </p>

      <ul class="warning-list">
        <li class="warning-list-item">
          <img
            src="@/assets/icons/warning.svg"
            alt="Warning Icon"
            class="warning-icon"
          />Any custom images or link tracking hosted on our servers will be
          removed over time. This could result in some emails not working as
          expected.
        </li>
        <li class="warning-list-item">
          <img
            src="@/assets/icons/warning.svg"
            alt="Warning Icon"
            class="warning-icon"
          />Any custom images used in designs will be lost.
        </li>
        <li class="warning-list-item">
          <img
            src="@/assets/icons/warning.svg"
            alt="Warning Icon"
            class="warning-icon"
          />If you uninstall the app completely, unsubscribes on any previously
          sent out emails will not be able to be tracked or actioned.
        </li>
      </ul>

      <div class="text-center text-sm font-bold">
        <p v-if="contactOptions" class="mb-4">
          Would you like to speak to a member of our team before continuing?
        </p>

        <div v-if="contactOptions" class="flex flex-col items-center">
          <div class="flex justify-center mb-2">
            <Button class="xs primary mr-1" @click="onYesClick">Yes</Button>
            <Button class="xs danger ml-1" @click="onNoClick">No</Button>
          </div>
        </div>

        <div v-if="downgradeOptions" class="flex flex-col items-center">
          <div class="text-sm mb-6 lg:mb-8 text-danger mx-auto max-w-sm">
            <p class="mb-2">
              If you downgrade all premium features will be revoked immediately.
            </p>
            <p class="mb-0">
              To keep all the features, but still downgrade, we suggest
              downgrading closer to your next billing renewal date.
            </p>
          </div>

          <Button class="primary" @click="onKeepClick">Keep Features 🚀</Button>
          <p class="text-sm my-2 text-grey">or&hellip;</p>
          <Button class="danger mb-4 sm" @click="onDowngradeClick"
            >Accept and continue with downgrade</Button
          >
        </div>

        <div class="flex flex-col items-center">
          <Button class="link xs text-brand" to="/">Back to home</Button>
        </div>
      </div>
    </div>
  </Section>
</template>

<script>
import Section from "@/components/UI/Section";
import { getAccountId } from "@/lib/auth";

export default {
  name: "Downgrade",
  components: { Section },
  data() {
    return {
      contactOptions: true,
      downgradeOptions: false,
      downgradeUrl: this.$route?.params?.downgradeUrl,
    };
  },
  mounted() {
    this.checkForDowngradeUrl();
  },
  methods: {
    checkForDowngradeUrl() {
      if (!this.downgradeUrl) {
        this.$modal.show("error", {
          errors: [
            "You may already be on the free plan or have come to this page accidentally. Please contact us if you're looking to downgrade.",
          ],
          errorAction: () => {
            this.$modal.hide("error");
            this.$router.push({ name: "Home" });
          },
          errorActionLabel: "Back to home",
        });
      }
    },
    onDowngradeClick() {
      if (
        window.confirm(
          "Are you sure? This can't be undone and you will lose access to all the amazing features your plan has to offer 😧 Plus we'll really miss you and your awesome email designs!"
        )
      ) {
        this.$gtm.trackEvent({
          event: "promo-select-package",
          packageName: "Free",
          packagePrice: "0",
          accountId: getAccountId(),
        });

        window.document.location.href = this.downgradeUrl;
      }
    },
    onKeepClick() {
      this.$gtm.trackEvent({
        event: "promo-downgrade-cancel",
        accountId: getAccountId(),
      });

      this.$router.push({ name: "Home" });
    },
    onNoClick() {
      this.contactOptions = false;
      this.downgradeOptions = true;
    },
    onYesClick() {
      this.$gtm.trackEvent({
        event: "promo-downgrade-cancel",
        accountId: getAccountId(),
      });

      window.location.href = `mailto:support@promo.ai?subject=Promo.ai Downgrade Question&body=%0D%0A%0D%0A${getAccountId()}`;

      this.$router.push({
        name: "Home",
      });
    },
  },
};
</script>

<style scoped>
.warning-list {
  @apply list-reset max-w-xs mx-auto text-xs mb-8;

  @screen md {
    @apply max-w-sm text-sm;
  }
}

.warning-list-item {
  @apply text-xs font-sans font-bold text-grey-darkest mb-2;

  @screen sm {
    @apply mb-4 text-sm;
  }
}

.warning-icon {
  @apply mr-1 relative;
  top: 1px;
  width: 12px;

  @screen sm {
    @apply mr-2;
  }

  @screen lg {
    width: 14px;
  }
}
</style>
